import { Stack, Typography } from '@mui/material';

import { AutoSaveList } from '../../components';
import ClientSiblingFields from './ClientSiblingFields';
import { EMPTY_CLIENT_SIBLING_VALUES } from '../constants';
import { FAMILY_ADD_BUTTON_SX, FAMILY_SECTION_HEADING_SX } from '../styles';
import { CLIENT_SIBLING_FORM_SCHEMA } from '../validationSchema';
import {
  getClientSiblingRowLabel,
  mapClientSiblingToValues,
  toClientSiblingFieldPayload,
} from '../utils';

import type { ClientSiblingFormValues, ClientSiblingPayload, IClientSibling } from '../types';
import type { ClientSiblingSectionProps } from './types';

export default function ClientSiblingSection({
  siblings,
  disabled,
  isSaving,
  onCreate,
  onUpdate,
  onDelete,
}: ClientSiblingSectionProps) {
  return (
    <Stack gap={3} textAlign="left">
      <Typography variant="h6" sx={FAMILY_SECTION_HEADING_SX}>
        Client&apos;s sibling
      </Typography>
      <AutoSaveList<ClientSiblingFormValues, IClientSibling, ClientSiblingPayload>
        addButtonLabel="Add sibling"
        addButtonSx={FAMILY_ADD_BUTTON_SX}
        disabled={disabled}
        emptyReadOnlyMessage="No siblings added"
        emptyValues={EMPTY_CLIENT_SIBLING_VALUES}
        entries={siblings}
        getDeleteConfirm={(row) => ({
          title: 'Confirm sibling deletion?',
          message: `You are about to delete "${row.sibling_relationship ?? 'this sibling'}"`,
        })}
        getRowKey={(row) => row.id}
        getRowLabel={getClientSiblingRowLabel}
        isSaving={isSaving}
        mapRowToValues={mapClientSiblingToValues}
        newEntryLabel="New sibling"
        onCreate={onCreate}
        onDelete={onDelete}
        onUpdate={onUpdate}
        renderFields={({ formik, disabled: rowDisabled, readOnly, saveField }) => (
          <ClientSiblingFields
            disabled={rowDisabled}
            formik={formik}
            readOnly={readOnly}
            saveField={saveField}
          />
        )}
        toFieldPayload={toClientSiblingFieldPayload}
        validationSchema={CLIENT_SIBLING_FORM_SCHEMA}
      />
    </Stack>
  );
}
